import { toNotFoundPage } from '@/feature/navigation/services/navigation.routing'
import { assertNever } from '@/lib/typescript/assertNever'

export const OUR_PRODUCTS_URL_KEYS_MAPPING: Record<Brands, string> = {
  prolians: 'nos-produits',
  hydralians: 'tous-nos-produits',
  dexis: 'nos-produits',
  destil_nl: 'onze-producten',
  ecom_en: 'our-products',
  dexis_nl: 'onze-producten',
}

/**
 * Go to the products page.
 */
export function toOurProductsPage() {
  switch (process.env.NEXT_PUBLIC_BRAND) {
    case 'prolians':
      return `/${OUR_PRODUCTS_URL_KEYS_MAPPING['prolians']}`
    case 'hydralians':
      return `/${OUR_PRODUCTS_URL_KEYS_MAPPING['hydralians']}`
    case 'dexis':
      return `/${OUR_PRODUCTS_URL_KEYS_MAPPING['dexis']}`
    case 'destil_nl':
      return `/${OUR_PRODUCTS_URL_KEYS_MAPPING['destil_nl']}`
    case 'ecom_en':
      return `/${OUR_PRODUCTS_URL_KEYS_MAPPING['ecom_en']}`
    case 'dexis_nl':
      return `/${OUR_PRODUCTS_URL_KEYS_MAPPING['dexis_nl']}`
    default:
      assertNever(process.env.NEXT_PUBLIC_BRAND)
  }
}

/**
 * Go to the product page.
 */
export function toProductPage(urlKey: string | null | undefined) {
  return urlKey ? `/${urlKey}` : toNotFoundPage
}

export function toEmbedProductPagePage(urlKey: string): string {
  return `/embed${toProductPage(urlKey)}`
}

/**
 * Go to the search product page.
 */
export function toSearchProductPage(code: string) {
  return `/search-product/${code}`
}
